<template>
  <div class="mx-auto">
    <v-card flat>
      <v-card-title class="blue--text">Informasi Sekolah dan Instruktur</v-card-title>
      <v-card-text>
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-hospital-building</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <div class="blue--text">
                      {{ $getDeepObj(sekolah, 'sekolah.data.nama') || '-' }}
                    </div>
                    <div class="black--text">
                      <b>NPSN : </b>
                      {{ $getDeepObj(sekolah, 'sekolah.data.npsn') || '-' }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col v-if="false" cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item-title>
                      <v-label color="caption"><small>Nama Kepala Sekolah </small></v-label>
                    </v-list-item-title>
                    <div class="link black--text body-2">
                      <div>-</div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item-title>
                      <v-label color="caption"><small>Alamat</small></v-label>
                    </v-list-item-title>
                    <v-list-item-subtitle class="link black--text body-2">
                      {{ $getDeepObj(sekolah, 'sekolah.data.alamat') || '-' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-2"></v-divider>
        <v-row>
          <v-col cols="12" md="7">
            <span class="font-weight-medium blue--text body-1" v-html="`Mekanisme Pembelajaran`"></span><br />
            <span class="grey--text" v-html="`Pilihlah Mekanisme Pembelajaran yang digunakan`"></span>
          </v-col>
          <v-col cols="12" md="5">
            <v-spacer></v-spacer>
            <div class="ml-auto">
              <div class="radio-outline">
                <template v-for="item in mBelajar">
                  <span class="ml-md-1" :key="item.k_kp_opsi_psp">
                    <input
                      type="radio"
                      :id="`belajar_${item.k_kp_opsi_psp}`"
                      v-model="form['k_belajar_psp']"
                      :value="`${item.k_kp_opsi_psp}`"
                      :disabled="isPreview"
                      checked
                    />
                    <label :for="`belajar_${item.k_kp_opsi_psp}`">{{ item.keterangan }}</label>
                  </span>
                </template>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-divider class="my-2"></v-divider>
        <template v-for="(item, i) in instruments">
          <div :key="i" class="black--text">
            <span class="font-weight-medium blue--text body-1" v-html="item.label"></span><br />
            <span class="grey--text" v-html="item.keterangan"></span>
            <div class="mt-3 pa-5 container">
              <template v-if="item.child">
                <v-card outlined flat v-for="(instrument, ins) in item.child" :key="ins">
                  <v-card-text class="black--text">
                    <div class="font-weight-medium">{{ instrument.label }}</div>
                    <div>{{ instrument.keterangan || '' }}</div>
                    <div class="container">
                      <v-row v-for="(child, c, i) in instrument.items" :key="c">
                        <v-col cols="12" md="9" sm="12" class="px-0">
                          {{ instrument.subLabel }}{{ i + 1 }}. {{ child }}
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                          <div class="radio-outline">
                            <template v-for="s in pilihan">
                              <span class="ml-md-1" :key="s">
                                <input
                                  type="radio"
                                  :id="`${c}_${s}`"
                                  v-model="form['jawaban'][c]"
                                  :value="`${s}`"
                                  :disabled="isPreview"
                                  checked
                                />
                                <label :for="`${c}_${s}`">{{ s === 1 ? 'Ya' : 'Tidak' }}</label>
                              </span>
                            </template>
                          </div>
                        </v-col>
                        <v-col v-if="Number(form['jawaban'][c]) === 1" cols="12" md="12" sm="12">
                          <v-expansion-panels flat>
                            <v-expansion-panel>
                              <v-expansion-panel-header class="px-0">
                                <template v-slot:default="{ open }">
                                  <div>
                                    <v-toolbar flat>
                                      <v-toolbar-title class="body-1 ml-n4">
                                        <v-avatar size="30">
                                          <v-icon dark color="warning">mdi-information</v-icon>
                                        </v-avatar>
                                        <span class="font-weight-medium">Lengkapi semua informasi berikut</span>
                                      </v-toolbar-title>
                                      <v-spacer></v-spacer>
                                      <span class="text-right blue--text">
                                        {{ open ? 'Tutup Detail' : 'Lihat Detail' }}
                                      </span>
                                    </v-toolbar>
                                  </div>
                                </template>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <div class="mt-2">
                                  <validation-provider
                                    name="Deskripsi Hambatan"
                                    rules="maxChar: 500"
                                    v-slot="{ errors }"
                                  >
                                    <v-textarea
                                      v-model="form['deskripsi'][c]"
                                      label="Deskripsi Hambatan"
                                      hint="Maksimal 500 karakter"
                                      persistent-hint
                                      dense
                                      outlined
                                      counter="500"
                                      :readonly="isPreview"
                                      @keydown="$emit('autosave')"
                                      :error-messages="errors"
                                    >
                                    </v-textarea>
                                  </validation-provider>
                                  <validation-provider name="Saran" rules="maxChar: 500" v-slot="{ errors }">
                                    <v-textarea
                                      v-model="form['saran'][c]"
                                      label="Saran / Solusi"
                                      hint="Maksimal 500 karakter"
                                      persistent-hint
                                      dense
                                      outlined
                                      counter="500"
                                      class="mt-2"
                                      :readonly="isPreview"
                                      @keydown="$emit('autosave')"
                                      :error-messages="errors"
                                    ></v-textarea>
                                  </validation-provider>
                                  <v-row>
                                    <v-col v-if="false" cols="12" md="7" sm="12">
                                      <div>PIC <i>(Person in Charge)</i></div>
                                      <template v-if="isPreview">
                                        {{ $getDeepObj(form, `k_pic_psp.${c}`) || 'belum dipilih' }}
                                      </template>
                                      <template v-else>
                                        <v-radio-group v-model="form['k_pic_psp'][c]" row>
                                          <v-radio
                                            v-for="(radio, r) in masters.pic || []"
                                            :key="r"
                                            :label="radio.keterangan"
                                            :value="radio.k_kp_opsi_psp"
                                            :readonly="isPreview"
                                          ></v-radio>
                                        </v-radio-group>
                                      </template>
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12">
                                      <div>Status</div>
                                      <template v-if="isPreview">
                                        {{ $getDeepObj(form, `k_progres_psp.${c}`) || 'belum dipilih' }}
                                      </template>
                                      <template v-else>
                                        <div class="mt-3">
                                          <template v-for="(master, m) in masters.progres || []">
                                            <v-btn
                                              :key="m"
                                              :outlined="form['k_progres_psp'][c] !== master.k_kp_opsi_psp"
                                              :color="m === 0 ? 'orange' : m === 1 ? 'primary' : 'success'"
                                              class="mx-md-1"
                                              small
                                              dark
                                              depressed
                                              @click="setOpsiPsp(c, master.k_kp_opsi_psp)"
                                            >
                                              {{ master.keterangan }}
                                            </v-btn>
                                          </template>
                                        </div>
                                      </template>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-col>
                        <v-col cols="12" md="12" sm="12">
                          <v-divider />
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </template>
              <template v-else>
                <v-row v-for="(child, c) in item.items" :key="c">
                  <v-col cols="12" md="9" sm="12" class="px-0"> {{ c }}. {{ child }} </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <div class="radio-outline">
                      <template v-for="s in pilihan">
                        <span class="ml-md-1" :key="s">
                          <input
                            type="radio"
                            :id="`${c}_${s}`"
                            v-model="form['jawaban'][c]"
                            :value="`${s}`"
                            :disabled="isPreview"
                            checked
                          />
                          <label :for="`${c}_${s}`">{{ s === 1 ? 'Ya' : 'Tidak' }}</label>
                        </span>
                      </template>
                    </div>
                  </v-col>
                  <v-col cols="12" md="12" sm="12">
                    <v-divider />
                  </v-col>
                </v-row>
              </template>
            </div>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
export default {
  props: {
    initValue: {
      type: Object,
      default: null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
  },
  components: { ValidationProvider },
  data() {
    return {
      form: {},
      pilihan: [1, 0],
      sekolah: {},
    };
  },
  computed: {
    instruments() {
      return {
        dasar: {
          label: 'Pertanyaan Dasar',
          keterangan: 'Isilah instrumen berikut berdasarkan informasi sebenarnya',
          items: {
            1: 'Terdapat pertemuan penyusunan silabus yang dihadiri seluruh guru kelas atau mata pelajaran',
            2: 'Terdapat pertemuan penyusunan Projek penguatan profil pelajar Pancasila yang dihadiri seluruh guru kelas atau mata pelajaran',
            3: 'Terdapat pertemuan antara guru dengan komunitas praktisi pendidikan',
            4: 'Terdapat pertemuan antara guru dengan orang tua dan komunitas ',
            5: 'Pembahasan mengenai bagaimana menciptakan keamanan dan iklim sekolah yang positif (isu, bullying, narkotika, hukuman fisik, kekerasan seksual) yang terjadi di sekolah',
            6: 'Komite pembelajaran mengikuti sesi penguatan pembelajaran dengan paradigma baru bersama instruktur nasional',
          },
          child: false,
        },
        lanjutan: {
          label: 'Pertanyaan Lanjutan',
          keterangan: 'Isilah instrument berikut berdasarkan informasi hambatan yang terjadi dalam satu bulan terakhir',
          child: [
            {
              label: 'A. Sumber Daya Manusia (SDM)',
              subLabel: 'A',
              keterangan:
                '(misalnya : keterbatasan jumlah PTK, kompetensi kepala dan guru, motivasi rendah, gagap teknologi)',
              items: {
                7: 'Jumlah PTK tidak mencukupi',
                8: 'Kompetensi/kapasitas rendah',
                9: 'Komitmen kepala sekolah/pengawas atau guru rendah',
                10: 'Berhalangan tetap karena kondisi kesehatan ',
              },
            },
            {
              label: 'B. Anggaran',
              subLabel: 'B',
              keterangan: '(misalnya : Keterbatasan anggaran untuk menjalankan program di satuan pendidikan)',
              items: {
                11: 'Anggaran belum tersedia',
                12: 'Anggaran Kurang',
              },
            },
            {
              label: 'C. Teknologi',
              subLabel: 'C',
              keterangan: '',
              items: {
                13: 'Aplikasi (misal, Aplikasi kurang user frienly, aplikasi tidak compatible pada perangkat tertentu, aplikasi sering error atau buging dll)',
                14: 'Perangkat keras (Laptop/tablet/smartphone)',
                15: 'Jaringan internet tidak ada/tidak stabil',
              },
            },
            {
              label: 'D. Kegiatan Pembelajaran',
              subLabel: 'D',
              keterangan: '',
              items: {
                16: 'Kegiatan pembelajaran belum berjalan (misalnya dikarenakan guru mangkir atau peserta didik tidak bisa mengikuti pembelajaran)',
                17: 'Perangkat ajar tidak memadai (keterbatasan akses terhadap buku teks, contoh modul ajar, contoh penguatan projek profil pelajar Pancasila)',
              },
            },
            {
              label: 'E. Dukungan Pemerintah Daerah ',
              subLabel: 'E',
              keterangan: '',
              items: {
                18: 'Anggaran',
                19: 'Kebijakan/regulasi',
                20: 'Rotasi',
                21: 'Dukungan pengawas',
              },
            },
            {
              label: 'F. Dukungan Internal Sekolah ',
              subLabel: 'F',
              keterangan: '',
              items: {
                22: 'Dukungan yayasan',
                23: 'Dukungan guru non komite pembelajaran',
              },
            },
            {
              label: 'G. Kondisi Mendesak',
              subLabel: 'G',
              keterangan: '',
              items: {
                24: 'Bencana alam',
                25: 'Pandemi COVID-19 (pembatasan akses,  kekhawatiran terkena wabah terutama di wilayah tanpa internet akibat pandemi, dll)',
                26: 'Lainnya',
              },
            },
          ],
        },
      };
    },

    mBelajar() {
      return (this.masters && this.masters.belajar) || [];
    },
  },
  methods: {
    reset() {
      this.form = {
        jawaban: {},
        k_progres_psp: {},
        deskripsi: {},
        saran: {},
        k_belajar_psp: null,
      };
    },

    initForm(value) {
      if (!value) return;
      const { sekolah, formulir } = value;
      const instruments = this.$getDeepObj(formulir, 'psp_kp_sekolah_instrumens.data') || [];
      this.sekolah = sekolah;

      this.$set(this.form, 'k_belajar_psp', formulir && formulir.k_belajar_psp ? `${formulir.k_belajar_psp}` : null);

      const keys = ['jawaban', 'k_progres_psp', 'deskripsi', 'saran'];
      instruments.forEach((item) => {
        keys.forEach((key) => {
          if (this.isPreview) {
            if (key === 'k_progres_psp') {
              this.$set(
                this.form[key],
                item.k_kp_instrumen_psp,
                this.$getDeepObj(item, 'm_kp_opsi_psp_progres.data.keterangan') || ''
              );
            } else {
              this.$set(this.form[key], item.k_kp_instrumen_psp, key === 'jawaban' ? Number(item[key]) : item[key]);
            }
          } else if (item[key] !== null) {
            this.$set(this.form[key], item.k_kp_instrumen_psp, key === 'jawaban' ? Number(item[key]) : item[key]);
          }
        });
      });
    },

    setOpsiPsp(index, value) {
      if (this.isPreview) return;
      this.$set(this.form.k_progres_psp, index, value);
    },

    getValue() {
      const jawaban = (this.form && this.form['jawaban']) || {};
      const keys = ['k_progres_psp', 'deskripsi', 'saran'];
      let form = [];
      Object.keys(jawaban).forEach((key) => {
        let obj = { k_kp_instrumen_psp: key, jawaban: jawaban[key] };
        keys.forEach((ins) => {
          if (this.$getDeepObj(this.form, `${ins}.${key}`)) {
            this.$set(obj, ins, this.$getDeepObj(this.form, `${ins}.${key}`));
          }
        });
        form.push(obj);
      });
      return {
        form: form,
        k_belajar_psp: this.form && this.form.k_belajar_psp ? Number(this.form && this.form.k_belajar_psp) : null,
      };
    },

    validate() {
      return true;
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
